<div class="footer-content">
  <span *scText="rendering.fields.text"></span>
  <span *scRichText="rendering.fields.feelists"></span>
</div>
